import { SearchTagsTray } from '../../../domain/search-tags-tray';
import {
  CreateSearchTagsPageItemRequestApiModel,
  SearchTagsPageItemApiModel,
  UpdateSearchTagsPageItemRequestApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { SearchTagsTrayViewModel } from './search-tags-tray.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';
import { SearchTagsTraySubType } from './search-tags-tray.component';

// 'SearchTagsTray'

/**
 * DOMAIN -> API
 */

export const mapSearchTagsTrayDomainModelToApiModel = (
  item: SearchTagsTray,
  pageVersionId?: string,
  tenantId?: string
): CreateSearchTagsPageItemRequestApiModel & UpdateSearchTagsPageItemRequestApiModel => {
  const commonProperties = mapperPipe(item, nameLocalizedMapperDomainToApi, targetingMapperDomainToApi, scheduledDateMapperDomainToApi);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    categoryListName: item.categoryListName,
    items: item.items.map((itemItem) => ({
      id: itemItem.id,
      order: itemItem.order,
      feedId: itemItem.feed?.id,
      contentGroupId: itemItem.contentGroup?.id,
      tagLocalized: {
        en: itemItem.tagLocalized.en,
        ar: itemItem.tagLocalized.ar,
      },
    })),
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */
export const mapSearchTagsTrayApiModelToDomainModel = (pageItem: SearchTagsPageItemApiModel): SearchTagsTray => {
  return remainderMapper(
    mapperPipe(pageItem, commonMapper, nameLocalizedMapperApiToDomain, targetingMapperApiToDomain, scheduledDateMapperApiToDomain),
    () => ({
      type: 'SearchTagsTray',
      displayServiceTypeIcon: true,
      categoryListName: pageItem.categoryListName,
      items: pageItem.items
        .sort((s) => s.order)
        .map((item) => {
          return {
            id: item.id,
            order: item.order,
            tagLocalized: {
              en: item.tagLocalized.en,
              ar: item.tagLocalized.ar,
            },
            feed: item['feed'],

            contentGroup: item.contentGroup
              ? {
                  id: item.contentGroup.id,
                  name: item.contentGroup.title,
                  modified: item.contentGroup.updatedAt,
                  referringPages: item.contentGroup.referringPageNames || [],
                }
              : null,
          };
        }),
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapSearchTagsTrayDomainModelToViewModel = (pageItem: SearchTagsTray): SearchTagsTrayViewModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.SearchTagsTray,
    categoryListName: pageItem.categoryListName,
    subType: pageItem.items[0]?.feed ? SearchTagsTraySubType.OSNPlusContentGroup : SearchTagsTraySubType.OndemandContentGroup,
    items: pageItem.items.map((item, index) => ({
      id: item.id,
      feed: item?.feed,
      contentGroup: item?.contentGroup,
      index: index + 1,
      tagLocalized: {
        en: item.tagLocalized.en,
        ar: item.tagLocalized.ar,
      },
      name: undefined,
    })),
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapSearchTagsTrayViewModelToDomainModel = (vm: SearchTagsTrayViewModel): SearchTagsTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'SearchTagsTray',
    categoryListName: vm.categoryListName,
    items: vm.items.map((item, index) => ({
      id: item.id,
      order: index,
      feed: item.feed,
      contentGroup: item?.contentGroup,
      tagLocalized: {
        en: item.tagLocalized.en,
        ar: item.tagLocalized.ar,
      },
    })),
  }));
};
